import { Injectable } from "@angular/core";
import { Query } from "@datorama/akita";
import { Observable } from "rxjs";
import { UserInfo } from "../api/gmi/auth/models/user-info.model";
import { InfoModel } from "../api/gmi/info/models/info.model";
import { AppState, AppStore } from "./app.store";

@Injectable()
export class AppQuery extends Query<AppState> {
    constructor(protected store: AppStore) {
        super(store);
    }

    public selectServerState(): Observable<InfoModel | null> {
        return this.select(state => state.serverState);
    }

    public selectUserInfo(): Observable<UserInfo | null> {
        return this.select("currentUser");
    }
}
